module.exports = __webpack_public_path__ + "static/media/file-medical-alt.1d602b19.svg";